<div class="remove-machine-mode-modal">
  <div class="machine-modal-header">
    <span>{{'remove_machine_mode' | translate}}</span>
    <img src="../../../assets/icon/cancel.svg" alt="" class="close-icon" (click)="closeModal()">
  </div>
  <div class="modal-body">
    <p [innerHTML]="translatedMessage"></p>
    
    <ul class="roadmap-list" *ngIf="roadmapList && roadmapList.length > 0">
      <li *ngFor="let item of roadmapList">
        {{ item?.roadmapName }} – <b>{{ item?.totalHazardCount }}</b> {{ 'hazard' | translate }}
      </li>
    </ul>
    
    <span class="warning-text" [innerHTML]="'remove_machine_mode_warning' | translate">
    </span>
  </div>

  <div class="modal-footer">
    <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="closeModal()">
      {{ 'no'| translate }}
    </ion-button>
    <ion-button class="app-btn" shape="round" fill="outline" color="primary" (click)="confirmRemoval()">
      {{ 'yes'| translate }}
    </ion-button>
  </div>
</div>